import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import ThemeToggle from "@/components/ThemeToggle";
import { motion } from "framer-motion";

const HIGHLIGHTS = [
  "One connected workspace for the whole business",
  "Plan, operate, collaborate and grow",
  "AI woven through every module",
];

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="relative min-h-screen lg:grid lg:grid-cols-2">
      {/* Brand panel */}
      <div className="relative hidden overflow-hidden border-r border-border bg-card lg:flex lg:flex-col lg:justify-between lg:p-12">
        <div className="grid-lines pointer-events-none absolute inset-0 opacity-40 [mask-image:radial-gradient(ellipse_at_30%_20%,black,transparent_70%)]" />
        <div
          className="pointer-events-none absolute -left-20 top-1/4 h-[420px] w-[420px] rounded-full opacity-20 blur-[110px]"
          style={{ background: "var(--brand-gradient)" }}
          aria-hidden="true"
        />
        <div className="relative">
          <Logo imgClass="h-8" />
        </div>
        <div className="relative">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
            className="font-display text-4xl font-semibold leading-[1.05] tracking-tight"
          >
            Run your business from one connected workspace.
          </motion.h2>
          <ul className="mt-8 space-y-3">
            {HIGHLIGHTS.map((h, i) => (
              <motion.li
                key={h}
                initial={{ opacity: 0, x: -12 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.2 + i * 0.1, ease: [0.16, 1, 0.3, 1] }}
                className="flex items-center gap-3 text-sm text-muted-foreground"
              >
                <span className="h-1.5 w-1.5 rounded-full bg-brand-teal" /> {h}
              </motion.li>
            ))}
          </ul>
        </div>
        <p className="relative text-xs text-muted-foreground">© {new Date().getFullYear()} StUpEco Workspace</p>
      </div>

      {/* Form panel */}
      <div className="relative flex min-h-screen flex-col px-5 py-8 sm:px-8 lg:py-12">
        <div className="flex items-center justify-between lg:hidden">
          <Logo imgClass="h-7" />
          <ThemeToggle />
        </div>
        <div className="absolute right-8 top-8 hidden lg:block">
          <ThemeToggle />
        </div>

        <div className="flex flex-1 items-center justify-center">
          <div className="w-full max-w-md py-10">
            <h1 className="font-display text-3xl font-semibold tracking-tight">{title}</h1>
            {subtitle && <p className="mt-2 text-sm text-muted-foreground">{subtitle}</p>}
            <div className="mt-8">{children}</div>
            {footer && <div className="mt-6 text-center text-sm text-muted-foreground">{footer}</div>}
          </div>
        </div>
      </div>
    </div>
  );
}
